import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from 'react-query'

import axiosInstance from '@/lib/axiosInstance'

/**
 * Hook: useCreateUserBookmark
 * -----------------------------
 * Creates a new user bookmark.
 *
 * @returns A mutation result that creates a new bookmark.
 */
export const useLogoutMutation = (
  options?: UseMutationOptions<void, unknown, void, unknown>,
): UseMutationResult<void, unknown, void, unknown> => {
  return useMutation<void, unknown, void, unknown>(async () => logout(), {
    ...options,
  })
}

/**
 * 2. Create User Bookmark
 * -------------------------
 * Creates a new user bookmark.
 *
 * @param payload - Request payload containing chat window type, chat window ID, user query ID, and query type.
 * @returns A promise resolving to the newly created UserBookmark.
 */
export const logout = async (): Promise<void> => {
  const url = `/api/v1/auth/session`
  await axiosInstance.delete(url)
}
